import { Card, Divider, Grid, Typography, Box } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import FormTextField from '../../../FormFields/FormTextField';
import FormNumberField from '../../../FormFields/FormNumberField';
import FormTitle from '../../../FormFields/FormTitle';
import { CLINICAL_REIMBURSEMENT } from '../../../formQuestionsEnum';
import { formCardStyle } from '../../../TransitionStyles';

StaffingForm.propTypes = {
  permissions: PropTypes.object,
};

export default function StaffingForm({ permissions }) {
  const [focusedField, setFocusedField] = useState(null);

  const fieldIds = [CLINICAL_REIMBURSEMENT.BUDGETED_MDS_HOURS.id, CLINICAL_REIMBURSEMENT.OPEN_POSITIONS.id];

  const showForm = fieldIds.some((id) => id in permissions);

  return (
    showForm && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Staffing
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          {CLINICAL_REIMBURSEMENT.BUDGETED_MDS_HOURS.id in permissions && (
            <Grid item xs={12} sm={3}>
              <Box display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                <FormTitle fieldAttributes={{ questionTitle: 'Budgeted MDS hours' }} />
                <FormNumberField
                  fieldName={CLINICAL_REIMBURSEMENT.BUDGETED_MDS_HOURS.fieldName}
                  fieldAttributes={{
                    isEditable: permissions[CLINICAL_REIMBURSEMENT.BUDGETED_MDS_HOURS.id],
                  }}
                  focusedField={focusedField}
                  setFocusedField={setFocusedField}
                  allowDecimal
                />
              </Box>
            </Grid>
          )}
          {CLINICAL_REIMBURSEMENT.OPEN_POSITIONS.id in permissions && (
            <Grid item xs={12} sm={9}>
              <Box display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                <FormTitle fieldAttributes={{ questionTitle: 'Open clinical reimbursement positions' }} />
                <FormTextField
                  fieldName={CLINICAL_REIMBURSEMENT.OPEN_POSITIONS.fieldName}
                  fieldAttributes={{
                    isEditable: permissions[CLINICAL_REIMBURSEMENT.OPEN_POSITIONS.id],
                  }}
                  focusedField={focusedField}
                  setFocusedField={setFocusedField}
                />
              </Box>
            </Grid>
          )}
        </Grid>
      </Card>
    )
  );
}
